// Image validation utilities for the AI food assistant

export const ALLOWED_IMAGE_TYPES = [
  'image/jpeg',
  'image/jpg', 
  'image/png',
  'image/gif',
  'image/webp',
  'image/bmp'
];

export const MAX_FILE_SIZE = 10 * 1024 * 1024; // 10MB

export const validateImageFile = (file) => {
  const errors = [];

  if (!file) {
    errors.push('No file selected');
    return { isValid: false, errors };
  }

  // Check file size
  if (file.size > MAX_FILE_SIZE) {
    errors.push('Image file is too large. Please choose an image under 10MB.');
  }

  // Check file type
  if (!ALLOWED_IMAGE_TYPES.includes(file.type)) {
    errors.push('Unsupported image format. Please use JPEG, PNG, GIF, WebP, or BMP files.');
  }

  // Check if file appears to be empty
  if (file.size === 0) {
    errors.push('The selected file appears to be empty or corrupted.');
  }

  return {
    isValid: errors.length === 0,
    errors
  };
};

export const getFileTypeError = (rejectedFiles) => {
  if (!rejectedFiles || rejectedFiles.length === 0) {
    return 'Invalid file selected.';
  }

  const rejection = rejectedFiles[0];
  
  if (rejection.errors.some(e => e.code === 'file-too-large')) {
    return 'Image file is too large. Please choose an image under 10MB.';
  }
  
  if (rejection.errors.some(e => e.code === 'file-invalid-type')) {
    return 'Unsupported image format. Please use JPEG, PNG, GIF, WebP, or BMP files.';
  }
  
  if (rejection.errors.some(e => e.code === 'too-many-files')) {
    return 'Please select only one image at a time.';
  }
  
  return 'Invalid image file. Please try a different image.';
};

export const handleApiError = (err, defaultMessage) => {
  console.error('API Error:', err);
  
  // Handle specific error responses from backend
  if (err.response?.data?.error) {
    return err.response.data.error;
  }
  
  if (err.response?.status === 400) {
    return 'Invalid or corrupted image file. Please try a different image.';
  }
  
  if (err.response?.status === 413) {
    return 'Image file is too large. Please choose a smaller image.';
  }
  
  if (err.response?.status === 408) {
    return 'Image analysis timed out. Please try again with a smaller image.';
  }
  
  return defaultMessage || 'Failed to process the image. Please ensure it shows food clearly and try again.';
};
